import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const UKGAdmissions = () => {
    useEffect(() => {
        document.title = 'UKG Admissions -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Admissions  </li>
                  
                 <li>Entry Level Admissions 2026-2027</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Entry Level Admissions 2026-2027 </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/UKG-ADMISSION-SCHEDULE-2026-27.pdf" target="_blank">  NOTIFICATION FOR ADMISSION
TO
NURSERY (BALVATIKA-1 / PRE SCHOOL-1) AND KG (2026-27)
                            </Link> </div>
                    </div>
                {/* <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/UKGAdmissions.pdf" target="_blank">  UKG ADMISSION SCHEDULE 2025-26
                            </Link> </div>
                    </div>
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/UKGAdmissionsCRITERIA.pdf" target="_blank"> POINTS CRITERIA FOR ADMISSION TO UKG CLASS 2025-26
                            </Link> </div>
                    </div> */}
                </div>
            </div>
        </div>
     </>
  )
}

export default UKGAdmissions